import React,{useEffect,useState} from "react";
// import { Card, CardHeader, Container, Row } from "reactstrap";
import { Link, useNavigate, useParams } from "react-router-dom";

import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  Row,
  Col,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  
} from "reactstrap";
import SubAdminModal from 'models/user.modal'
import { helper } from "lib/helper";
import EditPermission from "./EditPermission";
import SubAdmin from "models/subadmins.modal";

const EditUser = () => {
  const [modal, setModal]= useState(false);
  const [addsLoadig, setAddsLoadig] = useState(false);
  const [dataList, setDataList] = useState(null);
  const navigate = useNavigate();
  const parmas = useParams();
  const [permissionslist, setPermissionslist]= useState();

  const toggleModal=()=>{
    setModal(!modal);
  }
  const handleSubmitEdituser = (event) => {
    setAddsLoadig(true);
    event.preventDefault();
    const form = new FormData(event.target);
    form.append("id", parmas.id);
    // You can adjust the header configuration according to your API requirements
    SubAdminModal
      .editUser(form)
      .then((response) => {
        helper.sweetalert.toast("Your User Edit.", "success");
        getListDataByid();
        setAddsLoadig(false);
        // Display success message to the user
      })
      .catch((error) => {
        // console.log(error);
      });
  };
const permission =()=>{
  SubAdmin.listbyid(parmas.mid)
  .then((responce)=>{
  setPermissionslist(responce?.data?.data)
  console.log("gud",responce)
  })
  .catch((error)=>{
    console.log("error",error)
  })
}
  const getListDataByid = () => {
    const data = {
      id: parmas?.id,
    };
    // Assuming '19' is the ID you want to send
    SubAdminModal
      .listbyUserid(data)
      .then((response) => {
       
        setDataList(response.data.data);
        // console.log(response.data.data, "data");
      })
      .catch((error) => {
        // console.log(error);
      });
  };
 

 
  useEffect(() => {
    if (parmas.id != "") {
      getListDataByid();
      permission();
    }
  }, []);
console.log("datalist ----",permissionslist)
  return (
    <>
      <Container className="pt-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">Edit User</h3>
              </CardHeader>
              <CardBody>
              <Form onSubmit={handleSubmitEdituser}>
                    <Row>
                      <Col md={4}>
                        <FormGroup>
                          <Label for="exampleEmail">Name</Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            id="name"
                            name="name"
                            placeholder="Enter Name"
                            defaultValue={dataList?.name}
                          />
                        </FormGroup>
                      </Col>
                     
                      <Col md={3}>
                        <FormGroup>
                          <Label for="exampleEmail">Phone No.</Label>
                          <Input id="Priority" name="mobile"        defaultValue={dataList?.mobile} type="number"   placeholder="Enter Phone Number"  />
                        </FormGroup>
                      </Col>
                      <Col md={2}>
                        <FormGroup>
                          <Label for="exampleEmail">Updated Image</Label>
                          <UncontrolledTooltip
                                    placement="top"
                                    target="eyeTooltip"
                                  >
                                    Click to View
                                  </UncontrolledTooltip>
                         <img  id="eyeTooltip" src={dataList?.profile_pic} width="100px" height="50px" style={{border:"1px solid gray",cursor:"pointer"}} onClick={toggleModal}/>
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <Label for="exampleEmail">Update Image</Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            id="name"
                            name="profile_pic"
                            type="file"
                            defaultValue={dataList?.profile_pic}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={4}>
                        <FormGroup>
                          <Label for="exampleEmail">Email*</Label>
                          <Input
                          required
                            
                            name="email"
                            type="email"
                          
                            defaultValue={dataList?.email
                            }
                          />
                        </FormGroup>
                      </Col>

                      <Col md={4}>
                      <FormGroup>
                          <Label for="exampleEmail">Designation</Label>
                          <Input
                            id="Desginatio"
                            name="designation"
                            type="text"
                            placeholder="*Enter Designation"
                            defaultValue={dataList?.designation}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                      <FormGroup>
                          <Label for="exampleEmail">Password</Label>
                          <Input
                            id="password"
                            name="password"
                            type="password"
                            placeholder="*Enter Password"
                            defaultValue={dataList?.password}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    {/* <Row>
                      <Col md={12}>
                        <SubAdminPermission/>
                      </Col>
                    </Row> */}

                    {/* <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Added Date</Label>
                    <Input id="contact" name="contact" type="number" />
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Status</Label>
                    <Input id="status" name="status" type="select">
                      <option value="">Activate</option>
                      <option value="option1">Deactivate</option>
                      <option value="option2">Pending</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row> */}

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop:"20px"
                      }}
                    >
                      
{/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
                        <Button
                          color="primary"
                          type="submit"
                          style={{ float: "left", marginLeft: "5%" ,backgroundColor:"#080278",color:"white"}}
                        >
                          Save
                        </Button>
                      {/* )} */}
                    </div>
                  </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
        <Row><Col md={12}>
          <EditPermission permissionslist={permissionslist}/></Col>
        </Row>
        <Modal isOpen={modal} toggle={toggleModal} size="lg">
      <ModalHeader toggle={toggleModal}>
          <h4>Profile Image</h4>
        </ModalHeader>
        <ModalBody >
         
         <img src={dataList?.profile_pic} width="750px" height="460px"  style={{ 
            maxWidth: "100%", // Makes the image scale within the container width
            height: "auto",   // Keeps the aspect ratio intact
            border: "2px solid gray"
          }} />
        </ModalBody></Modal>
      </Container>
    </>
  );
};


export default EditUser
